<template>
  <VAppBar v-if="!hideHeaderOnMobile" elevation="0" border>
    <VToolbar color="white">
      <template v-if="isMobileBrandHeader" #title>
        <BaseLogo />
      </template>

      <template v-else-if="isMobileSubHeader" #title>
        <span class="font-weight-bold text-gray-700 text-lg">
          {{ pageTitle }}
        </span>
      </template>

      <template v-else #title>
        <span class="font-weight-bold text-gray-700">
          {{ pageTitle }}
        </span>
      </template>

      <template #append>
        <div class="d-flex align-center ga-4 px-1 px-lg-4">
          <TheHeaderUserSection :compact="mobile" />

          <button
            v-if="isMobileSubHeader"
            type="button"
            class="the-header__icon-btn d-inline-flex align-center justify-center border-0 bg-transparent cursor-pointer pa-0"
            aria-label="بازگشت"
            @click="onBack"
          >
            <VIcon icon="arrowLeft" size="24" color="gray-500" />
          </button>

          <VBtn v-if="!mobile && pageHasBack" :ripple="false" @click="onBack">
            <span>بازگشت</span>
            <VIcon icon="arrowLeft" />
          </VBtn>
        </div>
      </template>
    </VToolbar>
  </VAppBar>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { VAppBar, VToolbar, VBtn, VIcon } from 'vuetify/components'
import TheHeaderUserSection from './TheHeaderUserSection/TheHeaderUserSection.vue'
import BaseLogo from '@/modules/Core/components/base/BaseLogo/BaseLogo.vue'
import { useResponsiveLayout } from '@/modules/Core/composables'
import { isBottomNavRootPath } from '@/modules/Core/constants/bottomNav'

defineOptions({
  name: 'TheHeader',
})

const route = useRoute()
const router = useRouter()
const { mobile } = useResponsiveLayout()

const pageTitle = computed(() => (route.meta.title ? route.meta.title : ''))

const pageHasBack = computed(() => route.meta.pageHasBack ?? false)

const hideHeaderOnMobile = computed(
  () => mobile.value && Boolean(route.meta.hideHeaderOnMobile)
)

const isMobileBrandHeader = computed(
  () => mobile.value && isBottomNavRootPath(route.path)
)

const isMobileSubHeader = computed(
  () => mobile.value && !isMobileBrandHeader.value && !hideHeaderOnMobile.value
)

function onBack() {
  router.back()
}
</script>

<style scoped>
.the-header__icon-btn {
  width: 32px;
  height: 32px;
}
</style>
